import React from 'react';
import { Box, Paper, Stack, Typography } from '@mui/material';
import { AddCircle, Map, Notifications, Person, Settings } from '@mui/icons-material';
import { useLocation, useNavigate } from 'react-router-dom';

const navItems = [
  { label: 'Home', icon: <Map />, path: '/index', match: ['/', '/index'], value: 0 },
  { label: 'Notifiche', icon: <Notifications />, path: '/notifications', match: ['/notifications'], value: 1 },
  { label: 'Crea', icon: <AddCircle />, path: '/table', match: ['/table'], value: 2 },
  { label: 'Profilo', icon: <Person />, path: '/user', match: ['/user'], value: 3 },
  { label: 'Altro', icon: <Settings />, path: '/settings', match: ['/settings'], value: 4 },
];

export default function BottomNavigationBar({ valueToHighlight }) {
  const navigate = useNavigate();
  const location = useLocation();

  const inferred = navItems.find((item) => item.match.some((path) => {
    if (path === '/') return location.pathname === '/';
    return location.pathname.startsWith(path);
  }));
  const activeValue = valueToHighlight ?? inferred?.value ?? 0;

  const handleNavigate = (item) => {
    if (item.path === '/table') {
      localStorage.removeItem('searchedPlace');
      localStorage.removeItem('lastQueryPlace');
      localStorage.removeItem('tableVenue');
    }
    navigate(item.path);
  };

  return (
    <Paper
      component="nav"
      aria-label="Navigazione principale"
      elevation={0}
      sx={{
        position: 'fixed',
        left: 0,
        right: 0,
        bottom: 0,
        zIndex: 55,
        minHeight: 'var(--cv-bottom-nav-height)',
        bgcolor: 'rgba(252, 249, 245, 0.96)',
        backdropFilter: 'blur(14px)',
        borderTop: '1px solid rgba(223, 191, 193, 0.45)',
        borderRadius: '22px 22px 0 0',
        boxShadow: '0 -4px 20px rgba(29, 29, 27, 0.05)',
        pl: 'max(8px, env(safe-area-inset-left, 0px))',
        pr: 'max(8px, env(safe-area-inset-right, 0px))',
        pb: 'calc(8px + var(--cv-safe-area-bottom))',
        pt: 1,
      }}
    >
      <Stack direction="row" alignItems="center" justifyContent="space-around" sx={{ maxWidth: 720, mx: 'auto', minHeight: 65, gap: 0.25 }}>
        {navItems.map((item) => {
          const active = activeValue === item.value;
          return (
            <Box
              key={item.label}
              role="button"
              data-analytics-action={`nav_${["home", "notifications", "create", "profile", "settings"][item.value]}`}
              aria-current={active ? 'page' : undefined}
              tabIndex={0}
              onClick={() => handleNavigate(item)}
              onKeyDown={(event) => {
                if (event.key === 'Enter' || event.key === ' ') handleNavigate(item);
              }}
              sx={{
                flex: 1,
                minWidth: 0,
                maxWidth: 110,
                px: 0.5,
                py: 0.75,
                borderRadius: 3,
                color: active ? '#fff' : 'text.secondary',
                bgcolor: active ? 'primary.container' : 'transparent',
                cursor: 'pointer',
                transition: 'transform 160ms ease, background-color 160ms ease',
                '&:active': { transform: 'scale(0.95)' },
                '&:hover': { bgcolor: active ? 'primary.container' : 'rgba(229, 226, 222, 0.45)' },
              }}
            >
              <Stack alignItems="center" spacing={0.25}>
                {React.cloneElement(item.icon, { sx: { fontSize: 24 } })}
                <Typography variant="caption" sx={{ fontWeight: 600, fontSize: { xs: 11, sm: 12 }, lineHeight: 1.5, whiteSpace: 'nowrap', color: 'inherit' }}>
                  {item.label}
                </Typography>
              </Stack>
            </Box>
          );
        })}
      </Stack>
    </Paper>
  );
}
